// Centralised brand assets
export const ASSETS = {
  // Official logo — transparent white PNG (provided by client)
  logoWhite:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/ala5ykm3_paco_cabrera_logo_blanco_transparente.png",
  logoWhiteOnBlack:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/ala5ykm3_paco_cabrera_logo_blanco_transparente.png",
  logoGoldOnBlack:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/trfn2idr_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2005_20_06%20PM.png",
  logoBlackOnWhite:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/8bbgoa30_ChatGPT%20Image%20Jun%2010%2C%202026%2C%2005_18_32%20PM.png",

  // Hero — enclave aerial render
  heroVilla:
    "https://customer-assets.emergentagent.com/job_fe01ecbf-43e5-44ed-b050-d01b10f405c9/artifacts/evqng8qb_Para%20fondo.jpeg",

  // Real Barú aerial map (corrected version)
  baruMap:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/6zqtnbq7_mapa%20baru%202.png",

  // Vive sin ruido (3 pillars) — provided by client
  // Brisa = facade + palms (let the breeze in)
  pillarBrisa:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/n59o8fxo_VA%20apts%2028.jpeg",
  // Materia = garden + pond (real, natural materials)
  pillarMateria:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/574xtnwe_VA%20apts%2003.jpeg",
  // Calma = quiet luxury interior (inhabit calm)
  pillarCalma:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/o0ecgm2j_VA%20apts%2047.jpeg",

  // Cierre — apartment interior in the afternoon (cream sofa, warm light) = VA apts 40
  cierreInterior:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/eqagd8qs_VA%20apts%2040.jpeg",

  // Inversión blindada — dark relief topo of Barú
  relieveBaru:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/fkrft4vu_relieve.png",

  // Additional enclave renders (kept available for Proyectos page)
  enclaveAerial:
    "https://customer-assets.emergentagent.com/job_fe01ecbf-43e5-44ed-b050-d01b10f405c9/artifacts/zdetd2z1_VA%20apts%2040.jpeg",
  enclavePool:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/o0759kn7_VA%20apts%2002.jpeg",
  enclaveDay:
    "https://customer-assets.emergentagent.com/job_fe01ecbf-43e5-44ed-b050-d01b10f405c9/artifacts/evqng8qb_Para%20fondo.jpeg",
  pacoPortrait:
    "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=900&q=85",

  // ============ /proyectos page imagery ============
  // Hero — cenital (aerial) of project with surrounding forest
  proyectosHero:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/5e8n2kob_Panorama1Imagen_1%20en%20taman%CC%83o%20grande.jpeg",
  // Residencias — golden interior with stair and marble (VA apts 37)
  proyectosResidencias:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/3rpawer0_VA%20apts%2037.jpeg",
  // Enclaves — aerial of pool with palms and deck (VA apts 02)
  proyectosEnclaves:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/1ma4y89o_VA%20apts%2002.jpeg",

  // ============ /baru page imagery ============
  // Sunset aerial of Barú (per reference design)
  baruHero:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/rscrovu6_ChatGPT%20Image%20Jun%2011%2C%202026%2C%2001_57_35%20AM.png",
  // Dark topo / relief map of Barú with pulse marker (provided to accompany)
  baruRelieve:
    "https://customer-assets.emergentagent.com/job_paco-portfolio/artifacts/6zqtnbq7_mapa%20baru%202.png",

  // Cuaderno hero — sketchbook with architectural drawings (Unsplash, matches mood)
  cuadernoHero:
    "https://images.unsplash.com/photo-1517842645767-c639042777db?auto=format&fit=crop&w=2000&q=85",
};

export const SOCIAL = {
  instagram: "https://www.instagram.com/pacocabrera.arq/",
  youtube: "https://www.youtube.com/@arqpacocabrera",
};
